@if (toasts().length) {
  <div class="container-fluid">
    <div class="row justify-content-end">
      <div class="col-md-auto position-absolute">
        <div class="pt-3 w-100 overflow-x-hidden" style="min-width: 350px">
          @for (toast of toasts(); track toast.uuid) {
            <div class="mb-3" animate.enter="toastShow" animate.leave="fadeOut">
              <mwe-toast-notification
                [type]="toast.type"
                [showCloseButton]="true"
                [titleKey]="toast.title"
                [messageKey]="toast.message"
                [toast]="toast"
                (onCloseClick)="removeToast(toast.uuid)"
              />
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
